export default state => state.orderSummary?.discounts;
